// src/store/services/coach.js
import feathersClient, {
  makeServicePlugin,
  BaseModel
} from "../../feathers-client";

class Development_Actions extends BaseModel {
  constructor (data, options) {
    super(data, options);
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = "Development_Actions";
  // Define default properties here
  static instanceDefaults () {
    return {
      id: null,
      developmentAction: null,
      developmentActionId: null,
      status: null,
      traineeCompetenciesId: null,
      createdAt: null,
      updatedAt: null
    };
  }
}
const servicePath = "development-actions";
const servicePlugin = makeServicePlugin({
  Model: Development_Actions,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
